import React from 'react';
import Sansad2024  from 'views/Sansad2024';
const ExtraCurricularActivitiesPage = () => {
  return <Sansad2024 />;
};

export default ExtraCurricularActivitiesPage;